import {isFeatureEnabled} from '@github-ui/feature-flags'
import {isUIService} from '@github-ui/runtime-environment'

export function isReactCodespacesTabEnabled() {
  return isUIService || isFeatureEnabled('codespaces_tab_react')
}

export function isCachingEnabled() {
  return isFeatureEnabled('codespaces_tab_caching')
}
